// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import patientService from "../../../Services/patientService";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import doctorService from "../../../Services/doctorService";
// import expenseService from "../../../Services/expenseService";
// import expenseHeadService from "../../../Services/expenseHeadService";

// const AddEditExpense = () => {
//   const [patientData, setPatientData] = useState({
//     item_name: "",
//     amount: "",
//     expense_date: "",
//     description: "",
//     title: "",
//   });

//   const [expenseHeadData, setExpenseHeadData] = useState([]);

//   const { id } = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (id) {
//       // Fetch patient data for editing
//       const fetchPatientData = async () => {
//         try {
//           const response = await patientService.fetchPatientById(id); // Use the fetchPatientById service method
//           setPatientData(response.patient); // Assuming response has a 'patient' object
//         } catch (error) {
//           toast.error("Error fetching patient data.");
//         }
//       };

//       fetchPatientData();
//     }
//   }, [id]);

//   useEffect(() => {
//     const getExpenseHead = async () => {
//       try {
//         const response = await expenseHeadService.fetchAll();
//         console.log(response); // Log the response to confirm the structure
//         setExpenseHeadData(response.expensehead); // Access the patients array within response
//       } catch (error) {
//         toast.error("Error fetching Doctors");
//       }
//     };
//     getExpenseHead();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setPatientData({ ...patientData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await expenseService.update(id, patientData);
//         toast.success("Income updated successfully!");
//       } else {
//         await expenseService.create(patientData);
//         toast.success("Income added successfully!");
//       }
//       navigate("/account/expense");
//     } catch (error) {
//       toast.error("Error saving patient.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center text-[#F07F1B] font-[900] text-[30px]">
//         {id ? "Edit Expense" : "Add Expense"}
//       </h1>
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//           <label className="font-semibold text-sm">Item Name</label>
//             <input
//               label="Title"
//               variant="outlined"
//               fullWidth
//               name="item_name"
//               value={patientData.item_name}
//               onChange={handleChange}
//               required
//               className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//           <label className="font-semibold text-sm">Amount</label>
//             <input
//               label="Amount"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="amount"
//               value={patientData.amount}
//               onChange={handleChange}
//               required
//               className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//           <label className="font-semibold text-sm">Expense Date</label>
//             <input
//               label="Expense Date"
//               variant="outlined"
//               fullWidth
//               type="date"
//               name="expense_date"
//               value={patientData.expense_date}
//               onChange={handleChange}
//               required
//               InputLabelProps={{
//                 shrink: true,
//               }}
//               className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//             />
//           </div>

//           <div style={{ marginLeft: 20, width: "50%" }}>
//           <label className="font-semibold text-sm">Description</label>
//             <input
//               label="Description Note"
//               variant="outlined"
//               fullWidth
//               name="description"
//               value={patientData.description}
//               onChange={handleChange}
//               required
//               className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//             />
//           </div>
//         </div>

//         <div style={{ marginTop: 20, width: "49%" }}>
//           <FormControl fullWidth>
//           <label className="font-semibold text-sm">Medical Service</label>
//             <select
//               label="Expense Account"
//               name="title"
//               value={patientData.title} // Set the selected doctor's ID
//               onChange={handleChange}
//               required
//               className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//             >
//               {/* Static options */}
//               {/* <MenuItem value="1">General</MenuItem>
//               <MenuItem value="2">Salary</MenuItem>
//               <MenuItem value="3">Utilities</MenuItem>
//               <MenuItem value="4">Other</MenuItem> */}
//               {expenseHeadData.map((expensehead) => (
//                   <option key={expensehead.id} value={expensehead.id}>
//                     {expensehead.title}
//                   </option>
//                 ))}
//             </select>
//           </FormControl>
//         </div>


//         {/* <div>
//             <FormControl fullWidth>
//               <InputLabel>Assigned Doctor</InputLabel>
//               <Select
//                 label="Assigned Doctor"
//                 name="assigned_doctor"
//                 value={patientData.assigned_doctor} // Set the selected doctor's ID
//                 onChange={handleChange}
//                 required
//               >
//                 {doctorData.map((doctors) => (
//                   <MenuItem key={doctors.id} value={doctors.id}>
//                     {doctors.name}
//                   </MenuItem>
//                 ))}
//               </select>
//             </FormControl>
//           </div>
//         </div> */}

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="bg-white text-[#F07F1B] font-semibold shadow-lg border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//           >
//             Save and Continue
//           </button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditExpense;


import React, { useState, useEffect } from "react";
import {
  Button, Divider, Grid, TextField,
  MenuItem, Select, InputLabel, FormControl,
} from "@mui/material";
import patientService from "../../../Services/patientService";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import doctorService from "../../../Services/doctorService";
import expenseService from "../../../Services/expenseService";
import expenseHeadService from "../../../Services/expenseHeadService";

// ── Reusable components ──────────────────────────────────────
const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

const SelectField = ({ label, children, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <select
      {...props}
      className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
    >
      {children}
    </select>
  </div>
);

// ── Main Component ───────────────────────────────────────────
const AddEditExpense = () => {
  const [patientData, setPatientData] = useState({
    item_name: "",
    amount: "",
    expense_date: "",
    description: "",
    title: "",
  });

  const [expenseHeadData, setExpenseHeadData] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchPatientData = async () => {
        try {
          const response = await patientService.fetchPatientById(id);
          setPatientData(response.patient);
        } catch (error) {
          toast.error("Error fetching patient data.");
        }
      };
      fetchPatientData();
    }
  }, [id]);

  useEffect(() => {
    const getExpenseHead = async () => {
      try {
        const response = await expenseHeadService.fetchAll();
        console.log(response);
        setExpenseHeadData(response.expensehead);
      } catch (error) {
        toast.error("Error fetching Doctors");
      }
    };
    getExpenseHead();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatientData({ ...patientData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await expenseService.update(id, patientData);
        toast.success("Income updated successfully!");
      } else {
        await expenseService.create(patientData);
        toast.success("Income added successfully!");
      }
      navigate("/account/expense");
    } catch (error) {
      toast.error("Error saving patient.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ── Header ── */}
          <div className="bg-gray-800   px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Edit Expense" : "Add Expense"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              Fill in all fields to register the expense record
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-8 py-6">

              {/* ── Section 1: Basic Info ── */}
              <SectionLabel>Basic Information</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Item Name"
                  type="text"
                  name="item_name"
                  placeholder="e.g. Office Supplies"
                  value={patientData.item_name}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Expense Date"
                  type="date"
                  name="expense_date"
                  value={patientData.expense_date}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ── Section 2: Financial Details ── */}
              <SectionLabel>Financial Details</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Amount"
                  type="number"
                  name="amount"
                  placeholder="0"
                  prefix="Rs."
                  value={patientData.amount}
                  onChange={handleChange}
                  required
                />
                <SelectField
                  label="Expense Account Head"
                  name="title"
                  value={patientData.title}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Account Head --</option>
                  {expenseHeadData.map((expensehead) => (
                    <option key={expensehead.id} value={expensehead.id}>
                      {expensehead.title}
                    </option>
                  ))}
                </SelectField>
              </div>

              {/* ── Section 3: Additional Details ── */}
              <SectionLabel>Additional Details</SectionLabel>
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-[500] text-gray-500">Description</label>
                <textarea
                  name="description"
                  placeholder="Optional notes about this expense..."
                  value={patientData.description}
                  onChange={handleChange}
                  required
                  rows={3}
                  className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100 resize-none"
                />
              </div>

              {/* ── Footer ── */}
              <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => navigate("/account/expense")}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="submit"
                  className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
                >
                  {id ? "Update Expense →" : "Save Expense →"}
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields marked as required must be filled before saving.
        </p>
      </div>
    </div>
  );
};

export default AddEditExpense;